import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Account from "../../component/user/account.js";

import {getBase64} from '../../utils/tools';

class Accountcon extends React.Component{
  constructor(props) {
    super(props);

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileRemove = this.handleFileRemove.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.state = {
        formData: {
            firstname: "",
            surname: "",
            company_name: "",
            currency: "",
            siret: "",
            tva: "",
            tva_percent: "",
            address: "",
            logo: {},
            signature: {},
            stamp: {},
            organisations: []
        },
        submitted: false,
        valid: true,
        dataLoaded: false
    };

  }

  componentWillMount() {
      /* import les organisations */
      this.props.getOrganisationsAction().then(res => {
          /* import user */
          this.props.getUserAction().then(res => {
            if (!this.state.dataLoaded)
              this.mergeStateAndFormdata()
          })
      })

  }

  /* Merge les données de l'utilisateur avec celle du formulaire afin de le pré-remplir */
  mergeStateAndFormdata() {
    let listOfOrganisations = this.props.listOfOrganisations
    let user = this.props.user
    let formData = Object.assign({}, this.state.formData);
    formData.firstname = (user.firstname) ? user.firstname : "";
    formData.surname = (user.surname) ? user.surname : "";
    formData.company_name = (user.company_name) ? user.company_name : "";
    formData.currency = (user.currency) ? user.currency : "";
    formData.siret = (user.siret) ? user.siret : "";
    formData.tva = (user.tva) ? user.tva : "";
    formData.tva_percent = (user.tva_percent) ? user.tva_percent : "";
    formData.address = (user.address) ? user.address : "";
    formData.logo = (user.logo) ? {path: user.logo.path, title: user.logo.title} : {};
    formData.signature = (user.signature) ? {path: user.signature.path, title: user.signature.title} : {};
    formData.stamp = (user.stamp) ? {path: user.stamp.path, title: user.stamp.title} : {};

    let organisations_id = user.organisations.map((s) => {
      let obj = listOfOrganisations.find(o => o.id === s.id)
      return obj ? obj.id : ""
    })
    formData.organisations = organisations_id;
    this.setState({formData: formData, dataLoaded:true});
  }

  handleFileChange(event) {
    const target = event.target;
    if(target.files[0].type === "application/pdf" || target.files[0].type === "image/jpg" || target.files[0].type === "image/jpeg" || target.files[0].type=== "image/png") {
      getBase64(target.files[0]).then(res => {
        let formData = Object.assign({}, this.state.formData);

        formData[target.name] = {path: res, title: target.files[0].name};
        this.setState({formData: formData});
      });
    } else {
      this.props.displaySnackbar("error", "Format non pris en charge");
    }
  }

  handleFileRemove(id) {
    let formData = Object.assign({}, this.state.formData);
    formData[id] = {};
    this.props.closeConfirmation();
    this.setState({formData: formData});
  }

  handleInputChange(event) {
      if((event.target.name !== "longitude" && event.target.name !== "latitude")) {
          const {formData} = this.state;
          formData[event.target.name] = event.target.value;
          if (this.state.formData.organisations.length > 0) {
              this.setState({formData, valid: true})
          } else {
              this.setState({formData});
          }
      }
  }

  handleFormSubmit(e){
    e.preventDefault();
    if (this.state.formData.organisations.length === 0) {
      this.setState({valid:false})
    } else {
      this.setState({ submitted: true, valid:true }, () => {
        this.props.updateUserAction(this.props.user.id, this.state.formData)
        .then(res => {
            this.setState({
              submitted: false
            })
        })
        .catch(err => {
          this.setState({
            submitted: false
          })
        })
      })
    }
  }

  render(){
    return <Account
      formData={this.state.formData}
      submitted={this.state.submitted}
      handleFormSubmit={this.handleFormSubmit}
      handleInputChange={this.handleInputChange}
      handleSelectChange={this.handleSelectChange}
      handleFileChange={this.handleFileChange}
      user={this.props.user}
      listOfOrganisations={this.props.listOfOrganisations}
      displayConfirmation={this.props.displayConfirmation}
      handleFileRemove={this.handleFileRemove}
      valid={this.state.valid}
    ></Account>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Accountcon);



// WEBPACK FOOTER //
// ./src/container/user/account-container.js